import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import SectionHeading from "../components/SectionHeading";
import CTAButton from "../components/CTAButton";
import { Reveal, Lines } from "../components/Reveal";
import { FinalCTA } from "./Home";
import { COMPANY_FACTS, IMAGES, COMPANY } from "../data/content";

const Company = () => (
  <>
    <SEO title="Company | ARCH EXPO" description="ARCH EXPO coordinates the full project ecosystem — from spatial concept and technical planning to procurement, construction and handover." />
    <PageHero
      label="Company"
      titleLines={["Architecture", "beyond design."]}
      intro="We coordinate the full project ecosystem — from spatial concept and technical planning to procurement, construction and handover."
    />
    <section className="bg-paper pb-20 sm:pb-28" data-testid="company-profile">
      <div className="container-ax grid grid-cols-12 gap-8">
        <div className="col-span-12 lg:col-span-7">
          <Reveal className="overflow-hidden">
            <img src={IMAGES.company} alt="Contemporary curved architectural form (placeholder image)" loading="lazy" className="w-full aspect-[16/10] object-cover" />
          </Reveal>
        </div>
        <div className="col-span-12 lg:col-span-4 lg:col-start-9 flex flex-col justify-end">
          <Reveal i={1}>
            <p className="t-intro text-coal mb-8">
              One partner for <span className="font-serif italic font-normal">every</span> project phase.
            </p>
            <p className="text-graphite text-[15px] leading-relaxed">
              Arch Expo AG works with private clients, developers, investors and operators across Switzerland and internationally. We combine the mindset of an architecture studio with the discipline of a commercial delivery partner.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
    <section className="section-pad bg-paper" data-testid="business-model">
      <div className="container-ax grid grid-cols-12 gap-8">
        <div className="col-span-12 lg:col-span-5">
          <SectionHeading number="02" label="Business Model" title="Design intelligence, commercial delivery." className="mb-10" />
          <Reveal i={1}>
            <p className="text-graphite text-[15px] leading-relaxed mb-6">
              Arch Expo AG operates as an integrated partner: we take responsibility for the coordination of design, technical planning, sourcing and construction — under one agreement, with one accountable team.
            </p>
            <p className="text-graphite text-[15px] leading-relaxed">
              Our geographic reach extends across Switzerland and Europe, supported by an international network of manufacturers, fabricators and logistics partners.
            </p>
          </Reveal>
        </div>
        <div className="col-span-12 lg:col-span-6 lg:col-start-7">
          <Reveal i={2} className="overflow-hidden">
            <img src={IMAGES.companyAlt} alt="Minimal white architectural geometry (placeholder image)" loading="lazy" className="w-full aspect-[4/3] object-cover" />
          </Reveal>
        </div>
      </div>
    </section>
    <section className="section-pad bg-paper border-t border-ink/10" data-testid="company-facts">
      <div className="container-ax">
        <SectionHeading number="03" label="Company Facts" title="Legal identification." />
        <div className="max-w-3xl">
          {COMPANY_FACTS.map((f, i) => (
            <Reveal key={f.label} i={i}>
              <div className="grid grid-cols-12 gap-4 py-5 border-t border-ink/10 text-[15px]">
                <span className="col-span-5 sm:col-span-4 label-tech text-graphite pt-0.5">{f.label}</span>
                <span className="col-span-7 sm:col-span-8 text-coal">{f.value}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
    <FinalCTA />
  </>
);

export default Company;
